import { NavItem } from '@app/components/layout/sidenav/link/NavItem';
import { CanByRole } from '@app/core/auth/authorization/components/CanByRole';
import StreamerBoxIcon from '@app/modules/fleet/legacy/components/StreamerBoxIcon';
import { UserRole } from '@mi-front/core';
import { FormattedMessage } from 'react-intl';

/**
 * Sidenav entry for the fleet Balena devices listing.
 * Label is "Devices" in both Spanish and English.
 */
export function FleetLinks() {
  return (
    <CanByRole role={[UserRole.CLIENT_ADMIN, UserRole.SUPERADMIN]}>
      <NavItem to="/devices" icon={<StreamerBoxIcon />}>
        <FormattedMessage id="fleet.nav.title" defaultMessage="Devices" />
      </NavItem>
    </CanByRole>
  );
}
